import ItilGraph from "@/view/content/ItilGraph/ItilGraph.vue";
import CustomTable from "@/view/content/CustomTable/CustomTable.vue";
import dayjs from "dayjs";
import { GET_CASES } from "@/core/services/graphql/queries/service_management_report/belgium/queries";
import { INSTANCE_ENUM } from "@/core/constants.js";
import { OPERATOR_ENUM } from "../../../../../../../core/constants";

export default {
  name: "Cases",
  components: {
    ItilGraph,
    CustomTable
  },
  data() {
    return {
      date_from: dayjs().toISOString().substr(0, 10),
      date_to: dayjs().subtract(6, "M").toISOString().substr(0, 10),
      account_number: "",
      cases: {
        pagination: {
          limit: -1
        },
        filters: {
          sys_created_on: {
            value: [
              dayjs().subtract(6, "M").toISOString().substr(0, 10),
              dayjs().subtract(0, "M").toISOString().substr(0, 10)
            ],
            operator: OPERATOR_ENUM.BETWEEN
          }
        },
        headers: [
          { text: "Number", value: "number" },
          { text: "Opened", value: "opened_at" },
          { text: "Priority", value: "priority.value" },
          { text: "Title", value: "short_description" },
          { text: "Updated", value: "sys_updated_on" },
          { text: "State", value: "state" }
        ]
      }
    };
  },
  methods: {
    fetchData(loadObject) {
      this.date_from = loadObject.date_from;
      this.date_to = loadObject.date_to;
      this.cases.filters.sys_created_on = {
        value: [this.date_from, this.date_to],
        operator: OPERATOR_ENUM.BETWEEN
      };
      this.cases.filters.company = {
        value: loadObject.sys_id
      };
      this.$refs.itilTableCase.loadData({
        accountNumber: loadObject.account_number,
        filters: this.cases.filters,
        headers: this.cases.headers,
        instance: INSTANCE_ENUM.SNOW_GROUP,
        pagination: this.cases.pagination,
        queryOptions: { display_value: true },
        queryString: GET_CASES,
        reportType: "overview",
        tableName: "cases",
        title: "Cases Last 6 Months",
        value: "cases"
      });
      this.$refs.itilGraphCase.fetchData({
        account_number: loadObject.account_number,
        sys_id: loadObject.sys_id,
        itil_type: "cases",
        date_to: this.date_to,
        date_from: this.date_from
      });
    }
  }
};
